import { render } from "./rule-msg-box.vue?vue&type=template&id=dc83ed44&scoped=true&ts=true"
import script from "./rule-msg-box.vue?vue&type=script&lang=ts"
export * from "./rule-msg-box.vue?vue&type=script&lang=ts"

import "./rule-msg-box.vue?vue&type=style&index=0&id=dc83ed44&lang=scss&scoped=true"
import "./rule-msg-box.vue?vue&type=style&index=1&id=dc83ed44&lang=scss"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc83ed44"]])

export default __exports__